(function ($, Drupal, once) {
  'use strict';
  Drupal.behaviors.ptb_darkmode = {

    getUserValue: function() {
      return localStorage.getItem('ptbUserValue'); // 'dark' | 'light'
    },

    initDarkMode: function() {  
      let media = window.matchMedia('(prefers-color-scheme: dark)');
      const storedUserValue = this.getUserValue();

      // initialize toggle buttons
      const darkModeToggles = document.querySelectorAll('[data-ptb-darkmode]');
      if (darkModeToggles.length > 0) {
        darkModeToggles.forEach((toggle) => {
          toggle.addEventListener('click', (e) => {
            let isDark = document.documentElement.classList.contains('ptb-dark');
            let oppositeValue = isDark ? 'light' : 'dark';
            this.setDarkMode(oppositeValue, true);
         });
        });
      }

      // set dark mode according to OS or user storage if there
      if (storedUserValue) {
        this.setDarkMode(storedUserValue);
      } else {
        this.setDarkMode(media.matches ? 'dark' : 'light');
      }
    },

    storeUserMode: function(setting) {
      localStorage.setItem('ptbUserValue', setting);
    },

    setDarkMode: function(setting, storeValue=false) {

      if (setting == 'light') {
        document.documentElement.classList.remove('ptb-dark');
      } else {
        document.documentElement.classList.add('ptb-dark');
      }

      if (storeValue == true) {
        this.storeUserMode(setting);
      }

      // sets the home hero image if necessary
      if (Drupal.behaviors.weaver_tailwind_hero) {
        Drupal.behaviors.weaver_tailwind_hero.setHeroBGImage(setting);
      }
    },

    attach: function (context, settings) {

      $(once('ptb_darkmode', 'body', context)).each(function () {

        const ptb_darkmode = Drupal.behaviors.ptb_darkmode;
        ptb_darkmode.initDarkMode();
      });
    }
  };
})(jQuery, Drupal, once);